import React, { useState, useEffect } from 'react';
import './styles/Dashboard.css';
import { FaChevronRight, FaGlobe, FaHotel, FaNewspaper, FaUtensils, FaHiking, FaCalendar, FaRainbow, FaSignOutAlt, FaFileAlt, FaMap, FaUmbrellaBeach, FaSearch, FaSpa, FaRunning, FaShoppingBag, FaConciergeBell, FaBullhorn, FaUsers } from 'react-icons/fa';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axiosPost from '../../helpers/axios-helper';

export default function Dashboard() {
    const [menu, setMenu] = useState([
        {
            name: 'Management',
            type: 'header'
        },
        {
            id: 1,
            name: "Countries",
            type: 'option',
            ref: 'countries',
            icon: <FaGlobe />
        },
        {
            id: 2,
            name: "Hotels",
            type: 'option',
            ref: 'hotels',
            icon: <FaHotel />
        },
        {
            id: 4,
            name: "Restaurants",
            type: 'option',
            ref: 'restaurants',
            icon: <FaUtensils />
        },
        // {
        //     id: 5,
        //     name: "Experiences",
        //     type: 'option',
        //     ref: 'experiences',
        //     icon: <FaHiking />
        // },
        {
            id: 11,
            name: "Beaches",
            type: 'option',
            ref: 'beaches',
            icon: <FaUmbrellaBeach />
        },
        {
            id: 12,
            name: "Explore",
            type: 'option',
            ref: 'explore',
            icon: <FaSearch />
        },
        {
            id: 13,
            name: "Wellness & Ritual",
            type: 'option',
            ref: 'wellness',
            icon: <FaSpa />
        },
        {
            id: 14,
            name: "Play",
            type: 'option',
            ref: 'play',
            icon: <FaRunning />
        },
        {
            id: 15,
            name: "Shop Local",
            type: 'option',
            ref: 'shop-local',
            icon: <FaShoppingBag />
        },
        {
            id: 22,
            name: "Services",
            type: 'option',
            ref: 'services',
            icon: <FaConciergeBell />
        },
        {
            id: 6,
            name: "Events",
            type: 'option',
            ref: 'events',
            icon: <FaCalendar />
        },
        {
            id: 7,
            name: "Queer Landscape",
            type: 'option',
            ref: 'queer-landscape',
            icon: <FaRainbow />
        },
        {
            id: 3,
            name: "Articles",
            type: 'option',
            ref: 'articles',
            icon: <FaNewspaper />
        },
        {
            id: 8,
            name: "Site Pages",
            type: 'option',
            ref: 'site-pages',
            icon: <FaFileAlt />
        },
        {
            id: 9,
            name: "Country Profiles",
            type: 'option',
            ref: 'country-profiles',
            icon: <FaGlobe />
        },
        {
            id: 10,
            name: "Travel Guides",
            type: 'option',
            ref: 'travel-guides',
            icon: <FaMap />
        },
        {
            id: 11,
            name: "Sponsored Banners",
            type: 'option',
            ref: 'banners',
            icon: <FaBullhorn />
        },
        {
            id: 20,
            name: "LGBTQ+ Organisations",
            type: 'option',
            ref: 'organisations',
            icon: <FaUsers />
        },
        {
            id: 21,
            name: "Community Groups",
            type: 'option',
            ref: 'connect-groups',
            icon: <FaUsers />
        }
    ]);

    const [account, setAccount] = useState({
        first_name: 'Admin',
        last_name: 'User',
        role: 'Administrator'
    });
    
    const [selectedOption, setSelectedOption] = useState(1);
    const location = useLocation();
    const navigate = useNavigate();
    const [cookies, , removeCookie] = useCookies(['auth_token']);

    // Load account from localStorage on mount
    useEffect(() => {
        const storedAccount = localStorage.getItem('auth_account');
        if (storedAccount) {
            try {
                const parsed = JSON.parse(storedAccount);
                setAccount({
                    first_name: parsed.first_name || 'Admin',
                    last_name: parsed.last_name || 'User',
                    role: parsed.level === 1 ? 'Administrator' : 'Editor'
                });
            } catch (e) {
                console.error('Failed to parse account:', e);
            }
        }
    }, []);

    const handleLogout = () => {
        const token = cookies.auth_token;
        if (token) {
            axiosPost(
                'auth/logout',
                { 'Content-Type': 'application/json' },
                { token },
                () => {},
                () => {}
            );
        }
        removeCookie('auth_token', { path: '/' });
        localStorage.removeItem('auth_account');
        navigate('/dashboard/login');
    };

    // Update selected option based on current path
    React.useEffect(() => {
        const path = location.pathname.split('/').pop();
        const menuItem = menu.find(item => item.type === 'option' && item.ref === path);
        if (menuItem) {
            setSelectedOption(menuItem.id);
        }
    }, [location.pathname, menu]);

    const Sidebar = () => {
        const render_options = menu.map((item, index) => {
            if(item.type === 'header'){
                return (
                    <div className='SidebarHeader' key={`header-${index}`}>{item.name}</div>
                );
            }

            return (
                <Link 
                    to={item.ref} 
                    className={`SidebarOption ${(selectedOption === item.id) ? 'Active' : ''}`} 
                    key={`option-${item.id}`}
                    onClick={() => {
                        setSelectedOption(item.id);
                    }}
                >
                    <div className='SidebarOptionIcon'>
                        {item.icon}
                    </div>
                    <div className={`SidebarOptionText ${(selectedOption === item.id) ? 'Active' : ''}`}>
                        {item.name}
                    </div>
                    <FaChevronRight 
                        size={12} 
                        color={(selectedOption === item.id) ? '#1976d2' : '#fff'} 
                    />
                </Link>
            );
        });

        return (
            <div className='Sidebar'>
                <div className='SidebarAccount'>
                    <div className='SidebarAccountAvatar'></div>
                    <div className='SidebarAccountInfo'>
                        <div className='SidebarAccountInfoTitle'>
                            {account.first_name + ' ' + account.last_name}
                        </div>
                        <div className='SidebarAccountInfoSub'>{account.role}</div>
                    </div>
                </div>

                <div className='SidebarHeader' style={{color: '#fff'}}>Options</div>
                <div className='SidebarOptions'>
                    {render_options}
                </div>

                <div className='SidebarLogout' onClick={handleLogout}>
                    <FaSignOutAlt style={{ marginRight: '10px' }} />
                    Logout
                </div>
            </div>
        );
    };

    return (
        <div className='Dashboard'>
            <Sidebar />
            <div className='DashboardContent'>
                <Outlet />
            </div>
        </div>
    );
}
